import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import './projectTypeModal.css';
import CreateEdit from './CreateEdit';

function ProjectTypeCreateModal({ handleClose, productId, setNewValue }) {
  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={true} onClose={handleClose}>
      <DialogContent className="modalContainer">
        <CreateEdit
          closeCreateEditForm={handleClose}
          projectTypeditDatas={null}
          editStatus={false}
          productId={productId}
          setNewValue={setNewValue}
        />
      </DialogContent>
    </Dialog>
  );
}

export default ProjectTypeCreateModal;
